export const API_URL = `https://api.labresearch.ru/api`
